import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class ProjectsTableService {
    private disableAllButtonsRequestSource = new Subject<string>();

    public disableAllButtonsRequestAnnounced$ = this.disableAllButtonsRequestSource.asObservable();

    public announceDisableAllButtonsRequest(columnId: string) {
        this.disableAllButtonsRequestSource.next(columnId);
    }

    constructor() {
    }
}
